import React from "react";
import Skeleton from "react-loading-skeleton";
import { RollingCoinsType } from "../../compilers/RollingCoins";
import "../../stylesheet/components/rollingcoins/RollingCoins.scss";
import "../../stylesheet/components/rollingcoins/RollingCoinsOverlay.scss";

const numberOfCoins = 30;
type RollingCoinsTypes = {
  coins: RollingCoinsType[];
  currency: string;
  icon: string;
  setCurrency: (newCoin: string) => void;
};

//const currencies = ["nzd", "usd", "aed"];

const RollingCoinsOverlay: React.FC<RollingCoinsTypes> = ({
  coins,
  currency,
  icon,
  setCurrency,
}) => {
  //const [change, setChange] = useState<boolean>(false);
  const coinsGrid = () => {
    //console.log(coins);
    if (coins.length > 1) {
      return coins.map((coin) => {
        if (coin) {
          return (
            <div key={coin.id} className="individual-coin flex">
              <p className="p2 individual-coin__symbol">{coin.symbol}</p>
              <p className="p2 individual-coin__price">
                {icon}
                {coin.current_price.toFixed(2)}
              </p>
              <p className="p2 individual-coin__change-percentage">
                {String(coin.price_change_percentage_24h).includes("-") ? (
                  <span className="down">
                    {String(coin.price_change_percentage_24h.toFixed(2))}%
                  </span>
                ) : (
                  <span className="up">
                    {String(coin.price_change_percentage_24h.toFixed(2))}%
                  </span>
                )}
              </p>
            </div>
          );
        }
      });
    }
    return [...Array(numberOfCoins)].map((skeleton, i: number) => {
      return (
        <div key={i} className="individual-coin flex">
          <Skeleton width={40} />
          <Skeleton width={100} />
          <Skeleton width={60} />
        </div>
      );
    });
  };

  const changeCurrency = (event: React.ChangeEvent<HTMLSelectElement>) => {
    // setChange(!change);
    coins = [];
    setCurrency(event.currentTarget.value);
    // setChange(!change);
  };

  return (
    <>
      <div className="rolling-coin-overlay">
        <div className="rolling-coins-collection ">{coinsGrid()}</div>
        <div className="nav-item">
          <select className="currency-select" onChange={changeCurrency}>
            <option value={currency}>{currency}</option>
            <option value="AED">AED</option>
            <option value="USD">USD</option>
            <option value="JPY">JPY</option>
            <option value="CNY">CNY</option>
            <option value="INR">INR</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
            <option value="NZD">NZD</option>
          </select>
        </div>
      </div>
    </>
  );
};

export default RollingCoinsOverlay;
